import DlpPolicyMatchDetail from 'owa-service/lib/contract/DlpPolicyMatchDetail';
import DlpPolicyTipAction from 'owa-service/lib/contract/DlpPolicyTipAction';
import maxBy from 'lodash-es/maxBy';
import minBy from 'lodash-es/minBy';
import PolicyMatchWrapper from '../store/schema/PolicyMatchWrapper';

export function getHighestPriorityPolicyTipMatchDetail(
    policyMatchWrapper: PolicyMatchWrapper
): DlpPolicyMatchDetail {
    const policyMatchDetails = policyMatchWrapper.policyMatchDetails;
    const unifiedDLPRules = policyMatchDetails.filter(detail => detail.MatchPriority != 0);
    return unifiedDLPRules.length > 0
        ? minBy(unifiedDLPRules, detail => detail.MatchPriority)
        : maxBy(policyMatchDetails, detail => getDefaultActionPriority(detail.Action));
}

function getDefaultActionPriority(action: DlpPolicyTipAction): number {
    switch (action) {
        case DlpPolicyTipAction.NotifyOnly:
            return 0;
        case DlpPolicyTipAction.RejectUnlessFalsePositiveOverride:
        case DlpPolicyTipAction.RejectUnlessSilentOverride:
        case DlpPolicyTipAction.RejectUnlessExplicitOverride:
            return 1;
        case DlpPolicyTipAction.RejectMessage:
            return 2;
        default:
            return 3;
    }
}
